import React, {Component} from 'react'
import '../styles/Login.css'
import {Button} from "react-bootstrap";
import {Link} from "react-router-dom";
import AdminService from "./adminComponents/AdminService";

export default class LoginAdmin extends Component {

    constructor(props) {
        super(props);

        this.state = {
            login: '',
            pass: ''
        };

        this.handleLogin = this.handleLogin.bind(this);
        this.handlePass = this.handlePass.bind(this);
        this.keyPress = this.keyPress.bind(this)
    }

    componentDidMount() {
        this.nameInput.focus();
    }

    keyPress(e) {
        if (e.keyCode === 13) {
            this.onLogin()
        }
    }

    handleLogin(e) {
        this.setState({login: e.target.value})
    }

    handlePass(e) {
        this.setState({pass: e.target.value})
    }

    onLogin() {
        AdminService.getDostep(this.state.login, this.state.pass)
            .then(function (response) {
                if (response.status === 200) {
                    sessionStorage.setItem('adminLoggedIn', JSON.stringify({
                        login: this.state.login,
                        pass: this.state.pass
                    }));
                    window.location.replace('/admin')
                }
            }.bind(this)).catch(err => {
            console.log(err)
        });

    }

    render() {
        return <div>
            <div className="login">

                <div className="loginContainer container">
                    <h2>Panel administracyjny</h2>
                    <div className="inputLogin"><i className="fa fa-user"> </i>
                        <input ref={(input) => {
                            this.nameInput = input;
                        }} className="form-control inputLoginControl" value={this.state.login}
                               onChange={this.handleLogin} onKeyDown={this.keyPress} placeholder="Nazwa użytkownika..."
                               type="text"/></div>
                    <div className="inputLogin"><i className="fa fa-key"> </i>
                        <input className="form-control inputLoginControl" value={this.state.pass}
                               onChange={this.handlePass}
                               onKeyDown={this.keyPress} placeholder="Hasło..." type="password"/></div>
                    <div className="buttonLogin"><Link to={'/admin'}><Button bsStyle="success"
                                                                             onClick={() => this.onLogin()}>Zaloguj</Button></Link>
                    </div>
                </div>
            </div>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/admin/LoginAdmin.js